module.exports = __webpack_public_path__ + "static/media/mouse-gif.4c8e8ba5.gif";